// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"WaveVisualizer_mainContainer__CerKj","waveItem":"WaveVisualizer_waveItem__2OBu6"};